// TODO : display N2W amount relative to bet value.
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { useSigner, useContract } from "wagmi";
import { ethers } from "ethers";
import { useSnackbar } from "notistack";
import { useContext, useState } from "react";
import useSound from "use-sound";
import SessionContext from "../../../contexts/session";
import {
  MODULO_COINFLIP,
  MODULO_ETHEROLL,
  MODULO_ROLLADICE,
  MODULO_ROULETTE,
  MODULO_TWODICE,
  getRouletteRed,
} from "../../../games";
import { updateCommit } from "../../../models/transactions";
import { getBetMask, postData, FormatN2W } from "../../../utils";
import { useTranslation, Trans } from "react-i18next";

export default function ButtonBet({
  betAmount,
  modulo,
  inputs,
  disabled,
  reward,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const { settings } = useContext(SessionContext);

  const {
    selectedNetwork,
    isAwaitingWallet,
    setIsAwaitingWallet,
    setPending,
    setHasInsufficientFunds,
    setIsBelowMinimumBet,
    volume,
  } = useContext(SessionContext);

  const { data: signer } = useSigner({ chainId: selectedNetwork.chainIdDec });

  const n2wContract = useContract({
    address: selectedNetwork.contract.address,
    abi: selectedNetwork.contract.abi,
    signerOrProvider: signer,
  });

  const [playStart] = useSound("/audio/start.wav", { volume });

  async function postBet() {
    try {
      playStart();
      // setTempError();
      setIsAwaitingWallet(true);
      setHasInsufficientFunds(false);
      setIsBelowMinimumBet(false);
      const betMask = getBetMask(modulo, inputs);
      const wei = ethers.utils.parseUnits(String(betAmount));
      let txPlaceBet;      
      if (selectedNetwork.version === 1.5) {
        txPlaceBet = await n2wContract.placeBet(betMask, modulo, {
          value: wei,
        });
      } else {
        const response = await postData("/api/v1/new_commit", {
          chainId: selectedNetwork.chainIdDec,
        });
        const { commit, commitLastBlock, v, r, s } = response.data;
        const betMask = getBetMask(modulo, inputs);
        const wei = ethers.utils.parseUnits(String(betAmount));        
        txPlaceBet = await n2wContract.placeBet(
          betMask,
          modulo,
          commitLastBlock,
          commit,
          v,
          r,
          s,
          { value: wei }
        );        
      }

      const key = enqueueSnackbar(
        <Stack>
          {/* <Typography>Placing bet...</Typography> */}
          <Typography>
            {modulo === MODULO_COINFLIP && t("The coin will flip soon")}
            {modulo === MODULO_ROLLADICE && t("The dice will roll soon")}
            {modulo === MODULO_TWODICE && t("The dices will roll soon")}
            {modulo === MODULO_ROULETTE && t("The wheel will spin soon")}
            {modulo === MODULO_ETHEROLL && t("The etheroll will spin soon")}
            ...
          </Typography>
          <Typography>
            <Trans t={t}>Avg wait time</Trans>{" "}
            {Math.floor(settings.waitTime / 1000)}s
          </Typography>
          {/* <Button>{truncateAddress(txPlaceBet.hash)}</Button> */}
        </Stack>,
        {
          persist: true,
          action: <CircularProgress />,
        }
      );
      setPending((pending) => [
        ...pending,
        {
          snackbarKey: key,
          placeBetHash: txPlaceBet.hash,
        },
      ]);
      setIsAwaitingWallet(false);
      const receipt = await txPlaceBet.wait();
      const iface = new ethers.utils.Interface(selectedNetwork.contract.abi);
      const events = receipt.logs
        .map((log) => {
          try {
            return iface.decodeEventLog("Commit", log.data, log.topics);
          } catch (err) {
            return undefined;
          }
        })
        .filter((event) => event);

      const commit_ = events[0].commit.toString();
      let blockNumber_ = events[0].blocknumber; // v2
      if (!blockNumber_) {
        // v1
        blockNumber_ = receipt.blockNumber;
      }

      await updateCommit(
        selectedNetwork,
        commit_,
        blockNumber_,
        txPlaceBet.hash
      );
    } catch (err) {
      setIsAwaitingWallet(false);
      if (err.code === 4001 || err.code === "ACTION_REJECTED") {
        return;
      }
      if (err.reason) {
        if (err.reason.includes("Amount should be within range.")) {
          setIsBelowMinimumBet(true);
        }
      }
      if (err.code === -32603 || err?.error?.code === -32603) {
        setHasInsufficientFunds(true);
      }
    }
  }

  return (
    <Stack spacing={1}>
      <Button
        className="btn-bet"
        disabled={disabled}
        variant="contained"
        onClick={postBet}
        size="large"
        sx={{ py: 2 }}
      >
        {isAwaitingWallet ? <CircularProgress /> : t("Bet")}
      </Button>
      <Typography color="success.main">
        <Trans t={t}>Bet to earn</Trans> <FormatN2W amount={reward} />
      </Typography>
    </Stack>
  );
}
